// extracted by mini-css-extract-plugin
export default {"filters":"VehiclesScreen_filters__ZAi4-"};